import { Link } from 'react-router-dom';
import { webtoonCategories } from '@/mocks/webtoons';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
            漫画分类
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {webtoonCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}